import { privateAxios } from '../requestsCollection';
import { IResponse } from '../types';
import { IAiAssist, IAiAssistNoteAssistPayload, IAiAssistPrompt } from './types';

export const getAiPrompt = (clinicId?: number): IResponse<IAiAssistPrompt> =>
  privateAxios({
    method: 'get',
    url: `clinic/${clinicId}/ai-assist/prompt`,
  });

export const getNoteAssist = ({
  clinicId,
  data,
}: {
  clinicId: number;
  data: IAiAssistNoteAssistPayload;
}): IResponse<IAiAssist> =>
  privateAxios({
    method: 'post',
    url: `clinic/${clinicId}/ai-assist/note-assist`,
    data,
  });

export default {};
